/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type MODERATION_MODE = "POST" | "PRE" | "%future added value";
declare const _CreateCommentReplyMutation_story$ref: unique symbol;
export type CreateCommentReplyMutation_story$ref = typeof _CreateCommentReplyMutation_story$ref;
export type CreateCommentReplyMutation_story = {
    readonly settings: {
        readonly moderation: MODERATION_MODE;
    };
    readonly " $refType": CreateCommentReplyMutation_story$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CreateCommentReplyMutation_story",
    "type": "Story",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "settings",
            "storageKey": null,
            "args": null,
            "concreteType": "StorySettings",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "moderation",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '17effa94b97c4daaacd8181d7101f720';
export default node;
